module.exports = __webpack_public_path__ + "static/media/expert6.ca2c81fb.png";